module.exports = __webpack_public_path__ + "static/media/jumbotronbg_small.bc477378.jpg";